module.exports = __webpack_public_path__ + "static/WernerB-b4b8c842396c3032627192291b5312fe.gif";